import React from 'react';
import Svg, { Path } from 'react-native-svg';

interface ArrowRightIconProps {
  size: number;
  color: string;
}

export function ArrowRightIcon({ size, color }: ArrowRightIconProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path
        d="M12.29 5.29C12.68 4.9 13.32 4.9 13.71 5.29L19.71 11.29C20.1 11.68 20.1 12.32 19.71 12.71L13.71 18.71C13.32 19.1 12.68 19.1 12.29 18.71C11.9 18.32 11.9 17.68 12.29 17.29L16.59 13H5C4.45 13 4 12.55 4 12C4 11.45 4.45 11 5 11H16.59L12.29 6.71C11.9 6.32 11.9 5.68 12.29 5.29Z"
        fill={color}
      />
    </Svg>
  );
}
